import { useWSModal } from "@wingspanhq/fe-component-library";

import { ModalConfirmExit } from "./ModalConfirmExit";

export const useModalConfirmExit = () =>
  useWSModal(ModalConfirmExit, {
    size: "S",
    title: "Exit version creation?"
  });
